<div class="modal-header">
  <h4 class="modal-title">{{'finalizeProject.popup.title' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-2 col-form-label">{{'finalizeProject.label.fNumber' | translate}}: *</label>
        <div class="col-md-8 form-inline">
          <label class="form-check-label" for="{{fNumberTextInputName}}">{{'finalizeProject.label.fNumberPreFix' | translate}}&nbsp;&nbsp;</label>
          <input class="form-control" formControlName="{{fNumberTextInputName}}" type="text"
            inputRestricter="^[0-9]*$" maxlength="7"
            [class.is-invalid]="!form.controls[fNumberTextInputName]?.valid">
          <div class="invalid-feedback">{{form.controls[fNumberTextInputName]?.errors?.messageKey | translate: {'0': form.controls[fNumberTextInputName]?.errors?.param} }}</div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button type="button" class="btn btn-primary btn-forward" (click)="finalizeButtonClickHandler()">{{'global.label.next' | translate}}</button>
</div>
